import { Autocomplete, TextField } from '@mui/material';
import { Api as CompaniesApi } from 'further-types/companies';

interface SectorSelectorProps {
  id?: string;
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  name: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
}

const CompanySectorSelector = ({
  id = 'sectorAutocomplete',
  value,
  onChange,
  name,
  placeholder = 'Select sector',
  error,
  helperText,
}: SectorSelectorProps) => {
  return (
    <Autocomplete
      id={id}
      getOptionKey={(option) => option}
      options={Object.values(CompaniesApi.Sector)}
      filterSelectedOptions
      onChange={(_event, newValue) => {
        onChange(newValue ?? undefined);
      }}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          required
          name={name}
          placeholder={placeholder}
          fullWidth
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default CompanySectorSelector;
